export const defaultPages = [
  'searching',
  'signup',
  'checkout_v3_tr',
  'upsell_an_private',
  'success',
];

const comboPages = ['features_2', 'paycheck2_pr1w_h_fastpay2', 'success'];
const legalFlow = ['one_pager_lf', 'signup_lf', 'paycheck_parental_lg2', 'success'];

export const flowsList: Record<string, string[]> = {
  default: [...legalFlow],
  tp: [
    'one_pager_all',
    'searching_2',
    'signup',
    'paycheck2_pr3_h_fastpay2_tp',
    'upsell_an_private_tp',
    'upsell_guide_tp',
    'success',
  ],
  lp1ch2: ['one_pager', ...defaultPages],
  lp11ch8: ['one_pager', 'searching', 'signup', 'checkout_h3_pp', 'upsell_an_private', 'success'],
  lp11ch8_vc: [
    'one_pager',
    'searching',
    'signup',
    'checkout_v3_pp',
    'upsell_an_private',
    'success',
  ],
  lp11ch8b: [
    'one_pager',
    'searching',
    'signup',
    'checkout_h3_pp_braintree',
    'upsell_an_private',
    'success',
  ],
  lp17ch17pr5: [
    'one_pager_all',
    'searching_2',
    'signup_testim',
    'paycheck1_pr5_h_win',
    'upsell_an_private',
    'success',
  ],
  stripe_test: ['auto-signup', 'checkout-test', 'success'],
  gn_test: ['one_pager_all_gn', ...comboPages],
  gn_lng_test: ['one_pager_all_gn_lng', ...comboPages],
  kwtt_test: ['one_pager_kwtt', ...comboPages],
  gnhdl_test: ['one_pager_all_gnhdl', ...comboPages],
  animation_onb: [
    'one_pager_ctn_onb',
    'start_cht_onb',
    'prc_lct_cht_onb',
    'zn_alrt_ctn_onb',
    'lc_hs_ctn_onb',
    'searching_ctn_onb',
    'signup_ctn_onb',
    'checkout_ctn_onb',
    'upsell_an_private_ctn_onb',
    'upsell_guide_ctn_onb',
    'success_ctn_onb',
  ],
  btstlk: [
    'one_pager_all',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck2_pr3_h_fastpay2',
    'upsell_an_private',
    'upsell_guide',
    'success',
  ],
  plv_lng_tst: [
    'one_pager_all_gn',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck2_pr3_h_fastpay2',
    'upsell_an_private',
    'success',
  ],
  ln_nw: [
    'one_pager_all_gn',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck2_pr3_h_fastpay2',
    'upsell_an_private',
    'success',
  ],
};
